import { BufferGeometry, Mesh, MeshStandardMaterial, NormalBufferAttributes, Object3D, Scene } from 'three';

let _scene: Scene = null;

/**
 * @return {void}
 */
export function SceneFindMesh<Geometry extends BufferGeometry<NormalBufferAttributes> = BufferGeometry<NormalBufferAttributes>, Material extends MeshStandardMaterial = MeshStandardMaterial>(
    needle: string | number,
    parent?: Object3D,
    key: keyof Object3D = 'name'): Mesh<Geometry, Material>
{
    parent = parent || _scene;
    needle = needle.toString().toLowerCase();

    for (const child of parent.children) {
        if (child.type === 'Mesh') {
            let value = child[key];

            if (typeof value === 'string' || typeof value === 'number') {
                if (value.toString().toLowerCase().indexOf(needle) !== -1) {
                    return child as Mesh<Geometry, Material>;
                }
            }
        } else if (child.children.length) {
            let mesh = SceneFindMesh<Geometry, Material>(needle, child, key);
            if (mesh) {
                return mesh;
            }
        }
    }

    return null;
}

export function SceneAdd(object: Object3D): void
{
    _scene.add(object);
}

export function SceneGet(): Scene
{
    return _scene;
}

export function SceneInit(): Scene
{
    return _scene = new Scene;
}
